// 主要的已驗證請求（帶 Bearer Token），baseURL 指向使用者系統。
// 本機開發走 webpack devServer proxy，故 baseURL 為空字串。
import axios from 'axios';
import { attachAuthInterceptor, attachResponseInterceptor } from './interceptors';

const usersRequest = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_USER_SYSTEM_URL : '',
  withCredentials: true,
  xsrfHeaderName: 'xsrf-token',
  xsrfCookieName: 'xsrf-token',
});

attachAuthInterceptor(usersRequest);
attachResponseInterceptor(usersRequest);

export default usersRequest;
